import styled from '@emotion/styled';
import {
  Button,
  usePhoneValidation,
  PhoneInput,
  theme,
  typography,
} from '@landsbankinn/ui';
import React, { useState } from 'react';

const Host = styled.div``;
interface IProps {
  title: string;
  description: string;
  login: (phoneNumer: string) => void;
  loading: boolean;
  error?: boolean;
}

const H2 = styled.h2`
  ${typography.h2}
  margin-bottom:20px;
`;
const P = styled.p`
  margin-bottom: 40px;
`;

const BigButton = styled(Button)`
  width: 100%;
  margin-top: 20px;
`;
export function PhoneAuthInput({
  title,
  description,
  login,
  loading,
  error,
}: IProps) {
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [phoneRef, isPhoneValid, errorMessage] =
    usePhoneValidation(phoneNumber);

  return (
    <Host>
      <H2>{title}</H2>
      <P>{description}</P>
      <PhoneInput
        label="Auðkenna með símanúmeri"
        value={phoneNumber}
        inputRef={phoneRef}
        isValid={isPhoneValid}
        errorMessage={errorMessage}
        onValueChange={({ value }) => setPhoneNumber(value)}
        inputSize="big"
        variant="noBorder"
        labelVariant="aboveInput"
        textAlign="center"
      />
      <BigButton
        bg={theme.colors.primary}
        title="Auðkenna"
        loading={loading}
        onClick={() => {
          login(phoneNumber.replaceAll('-', ''));
        }}
      />
      {error && <P>Ekki tókst að skrá þig inn með rafrænum skilríkjum</P>}
    </Host>
  );
}
